import { matchPath } from "react-router-dom";

import { ConsolePageKnownValue } from "generated/copilot-api-developer";
import { routes } from "routes";

export type TrackedRoute = { route: string; page: ConsolePageKnownValue };

// Only the routes listed here emit a page view event. Routes may contain
// parameters (e.g. "/dashboards/:id"), which are tracked as route params.
// The first matching route wins, so parameterized routes must be listed
// before any less specific route sharing the same prefix.
// TODO the current approach is far from ideal since we don't want to rebuild
// the routes here but since we are running a very old version of react-router
// there is no clean alternative. Once we start investing some efforts into
// improving the dev console this should be changed.
export const TRACKED_ROUTES: TrackedRoute[] = [
  {
    route: `${routes.DEVELOPERS}/${routes.FEEDBACK}`,
    page: "FEEDBACK_REPORTS",
  },
];

export const matchTrackedRoute = (
  pathname: string,
  trackedRoutes: TrackedRoute[] = TRACKED_ROUTES,
) => {
  for (const { route, page } of trackedRoutes) {
    const match = matchPath({ path: route, end: false }, pathname);
    if (match === null) continue;
    // matchPath with `end: false` matches on word boundaries, so "/feedback"
    // would also match "/feedback-events": only accept full segment matches.
    const rest = pathname.slice(match.pathname.length);
    if (rest === "" || rest.startsWith("/")) {
      return { page, route, path: pathname, params: match.params };
    }
  }
  return undefined;
};
